import { ApiPatchOperation, type PPLSyncStatus } from '@root/@types/types';

import { patchEntity } from './patchEntity';

interface SyncDataResponse {
  message: PPLSyncStatus;
  payload?: {
    incoming?: Record<string, any>;
    outgoing?: Record<string, any>;
    fullDefaultSection?: Record<string, any>;
    removedUnusedData?: string[];
    [key: string]: any;
  };
  error?: {
    errors?: any[];
    payload?: any;
  };
}

export const syncData = async (keepLocal?: boolean): Promise<SyncDataResponse> => {
  const response = await patchEntity<SyncDataResponse>({
    operation: ApiPatchOperation.SyncSubmissionData,
    keepLocal,
  });

  return response;
};
